import React, { useMemo, useState, useEffect, forwardRef, useRef } from "react";
import { useGroupBy, useTable, usePagination } from "react-table";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { DelayLink } from "./DelayLink";
import "./../styles/Tables.css";
import { FormControlLabel, Switch, InputLabel } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import info from "../../info.json";
import Api_Call from "../../ApiCall";
import PopOutModal from "./PopOutModal";
import { Box } from "@mui/material";

const ToggleHandler = ({ active, skill_id, user_id }) => {
  const [isToggled, setIsToggled] = useState(active);

  const handleToggle = async () => {
    setIsToggled(!isToggled);
    try {
      const api = new Api_Call();
      const data = await api.patchData(
        "UI/SKILL-ENROLLMENT",
        {
          header_id: "",
          skill_value: "",
          skill_id: skill_id,
          active: `${!isToggled == false ? 0 : 1}`,
        },
        info.BASE_URL_ADMIN
      );
      toast.success(data.body.msg);
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <div
        style={{
          // padding: "10px 20px",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
          // gap: "20px",
          // transform: "scale(0.5)",

          // C: isToggled ? "green" : "red",
          // color: "white",
          // border: "none",
          // borderRadius: "5px",
          // cursor: "pointer",
        }}
      >
        {/* <p>{isToggled ? "Yes" : "No"}</p> */}
        <p>{isToggled ? "Active" : "Inactive"}</p>
        <FormControlLabel
          id="toggle-btn"
          className="hoverable"
          style={
            {
              // transform: "scale(0.5)",
            }
          }
          control={
            <Switch
              checked={isToggled}
              style={
                {
                  // padding: "10px 20px",
                  // backgroundColor: isToggled ? "green" : "red",
                  // color: isToggled ? "green" : "red ",
                  // color: "white",
                  // border: "none",
                  // borderRadius: "5px",
                  // cursor: "pointer",
                }
              }
              className={`toggle-button ${isToggled ? "on" : "off"}`}
              onClick={handleToggle}
              label={isToggled ? "Active" : "Inactive"}
            >
              {isToggled ? "ON" : "OFF"}
            </Switch>
          }
        ></FormControlLabel>
      </div>
    </>
  );
};

const CheckBoxComponent = ({
  children,
  shouldBeChecked,
  skill_id,
  skillValue,
  skillsArrayForUser,
  setSkillsArrayForUser,
  isActive,
}) => {
  const [isChecked, setIsChecked] = useState(shouldBeChecked);

  const checkBoxHandler = () => {
    const valueOfBoxAfterChange = !isChecked;
    setIsChecked(!isChecked);

    const isSkillIdinArray = (skill_id) =>
      skillsArrayForUser.filter((item) => item.Skill_ID == skill_id).length > 0;
    const removeSkillIdFromarray = (skill_id) =>
      skillsArrayForUser.filter((item) => item.Skill_ID != skill_id);

    if (isSkillIdinArray(skill_id)) {
      setSkillsArrayForUser(removeSkillIdFromarray(skill_id));
    } else {
      setSkillsArrayForUser((prevV) => [
        ...prevV,
        {
          User_ID: sessionStorage.getItem("userIdInUserManagement"),
          Skill: skillValue,
          Skill_ID: skill_id,
        },
      ]);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginLeft: "10px",
      }}
    >
      <input
        type="checkbox"
        checked={isChecked}
        style={{ transform: "scale(1.5)" }}
        onChange={() => {
          checkBoxHandler(isChecked);
        }}
        disabled={isActive == 0 ? true : false}
      ></input>
      <span>{children}</span>
    </div>
  );
};
const SkillManagementTable = (props) => {
  var dynamicData = "";
  var dynamicColumn = "";
  var buttonDisplay = "";

  dynamicColumn = props.columns;
  dynamicData = props.tableData;
  const data = dynamicData;
  const columns = dynamicColumn;
  const [searchText, setSearchText] = useState("");

  const [selectedHeader, setSelectedHeader] = useState("");
  const [isCollasped, setIsCollasped] = useState(true);
  const [expanded, setIsExpanded] = useState(null);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [headerInPopup, setHeaderInPopup] = useState("");
  const [headerIDInPopup, setHeaderIDInPopup] = useState();
  const [skillsInPopup, setSkillsInPopup] = useState([]);
  const [skillInInputPopup, setSkillInInputPopup] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSkillEditButtonClicked, setIsskillEditButtonclicked] =
    useState(false);
  const [valueinInputAfterEdit, setvalueinInputAfterEdit] = useState();
  const [valueinInputAfterEdit_PrevState, setvalueinInputAfterEdit_PrevState] =
    useState();
  const [isEditingSkillSuccess, setIsEditingSkillSuccess] = useState(false);
  const [skillsArray, setSkillsArray] = useState(props.skillsArrayForUser);
  const inputRefSkillEditing = useRef(null);
  const [inputRef, setInputRef] = useState(null);
  const [isEditSkillClicked, setISEditSkillClicked] = useState(false);

  console.log(props.skillsArrayForUser);

  //   const [searchHeader, setSearchHeader] = useState("");
  //   const [filteredRows, setFilteredRows] = useState([]);

  //   const headerRows =
  //     searchHeader == ""
  //       ? []
  //       : props.tableData.filter((item) => {
  //           return item.Header.toLowerCase().includes(searchHeader.toLowerCase());
  //         });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    state: { pageIndex, pageSize: currentPageSize },
  } = useTable(
    {
      columns: props.columns,
      data: props.tableData,

      initialState: { pageIndex: 0, pageSize: 10 },
      // Start at first page
    },
    // useSortBy,
    usePagination // Add pagination plugin
  );

  //   const toggleCollaspe = (header) => {
  //     setCollaspedRows({ ...collaspedRows });
  //   };
  console.log(data);
  //   const filteredRows = rows.filter((row) => {
  //     const rowString = JSON.stringify(row.values).toLowerCase();
  //     if (searchText === null) {
  //       return false; // Skip this row if searchText is null
  //     }
  //     return rowString.includes(searchText.toLowerCase());
  //   });
  const filteredRows = rows.filter((row) => {
    const rowString = JSON.stringify(row.values).toLowerCase();
    if (searchText === null) {
      return false; // Skip this row if searchText is null
    }
    return rowString.includes(searchText.toLowerCase());
  });

  const handleQuestionClickNegative = () => {
    setSelectedHeader("");
    setIsExpanded(null);
  };

  const handleQuestionClick = (item) => {
    setIsExpanded(item);
    setSelectedHeader(item);
  };

  //   useEffect(() => {
  //     const commonEntries = filteredRows.filter((item) =>
  //       headerRows.some(
  //         (hItem) =>
  //           hItem.Skill_ID == item.Skill_ID &&
  //           hItem.Header == item.Header &&
  //           hItem.Title == item.Title
  //       )
  //     );
  //     if (skillRows.length == 0 && headerRows.length == 0) {
  //       setFilteredRows(rows);
  //     } else if (skillRows.length == 0) {
  //       setFilteredRows(headerRows);
  //     } else if (filteredRows.length == 0) {
  //       setFilteredRows(skillRows);
  //     } else if (commonEntries.length > 0) {
  //       setFilteredRows(commonEntries);
  //     }
  //   }, []);

  //   console.log("Filtered", filteredRows);
  //   console.log("Skill", skillRows);
  //   console.log("Header", headerRows);

  const [pageCount, setPageCount] = useState(0);

  const startRow = pageIndex * currentPageSize;
  const endRow = startRow + currentPageSize;
  //   const rowsForTable = rows.slice(startRow, endRow);
  const rowsForTable = filteredRows.slice(startRow, endRow);

  useEffect(() => {
    setPageCount(Math.ceil(filteredRows.length / currentPageSize));
  }, [filteredRows, currentPageSize]);
  //   useEffect(() => {
  //     setPageCount(Math.ceil(rows.length / currentPageSize));
  //   }, [rows, currentPageSize]);
  let lastHeader = null;

  useEffect(() => {
    gotoPage(0);
  }, [searchText]);

  const skillEditHandler = async (header_id, skill_id, active) => {
    console.log("---------------------------->");
    console.log({
      header_id: header_id,
      skill_value: valueinInputAfterEdit,
      skill_id: skill_id,
      active: active,
    });

    try {
      const api = new Api_Call();
      const data = await api.putData(
        `UI/SKILL-ENROLLMENT`,
        {
          header_id: header_id,
          skill_value: valueinInputAfterEdit,
          skill_id: skill_id,
          active: active,
        },
        info.BASE_URL_ADMIN
      );
      if (!data.success) {
        throw new Error("Error Occured");
      }
      console.log(data.body);
      setIsEditingSkillSuccess(true);

      props.settableData((prevV) => {
        return prevV.map((item) => {
          if (item.Skill_ID === isSkillEditButtonClicked) {
            return {
              ...item,
              Title: valueinInputAfterEdit,
            };
          }
          return item;
        });
      });
      toast.success(data.body.msg);
    } catch (error) {
      console.log(error.message);
    }
    // const api= new Api_Call();
    // const data= await api.putData(`UI/SKILL-ENROLLMENT`,{
    //     header_id: header_id,
    //     skill_value:valueinInputAfterEdit,
    //     skill_id: skill_id,
    //  active: active
    //   })
  };

  //   useEffect(() => {
  //     if (inputRefSkillEditing.current) inputRefSkillEditing.current.focus();
  //   }, [inputRefSkillEditing.current]);

  const handleSubmit = async () => {
    const payload = {
      header_id: headerIDInPopup,
      skill_value: skillsInPopup,
      skill_id: "",
      active: "",
    };
    setLoading(true);
    console.log(payload);
    try {
      const api = new Api_Call();
      const data = await api.postData(
        `UI/SKILL-ENROLLMENT`,
        payload,
        info.BASE_URL_ADMIN
      );

      const olddata = data.body["final_result"];
      //   const olddata = [
      //     {
      //       Skill_HeaderID: 2,
      //       Skill_Header: "Case Type Process",
      //       Skill_ID: 35,
      //       Skill_Value: "Skill mm",
      //       Skill_Active: 1,
      //     },
      //     {
      //       Skill_HeaderID: 2,
      //       Skill_Header: "Case Type Process",
      //       Skill_ID: 72,
      //       Skill_Value: "Skill dd",
      //       Skill_Active: 1,
      //     },
      //     {
      //       Skill_HeaderID: 2,
      //       Skill_Header: "Case Type Process",
      //       Skill_ID: 70,
      //       Skill_Value: "Skill ll",
      //       Skill_Active: 1,
      //     },
      //   ];

      //   {Skill_ID: 8, Title: 'Concurrent', isActive: 1, Header: 'UM Review Type', Header_ID: 3}
      const skillDatafromApi = olddata.map((item) => {
        return {
          Skill_ID: item.Skill_ID,
          Title: item.Skill_Value,
          isActive: item.Skill_Active,
          Header: item.Skill_Header,
          Header_ID: item.Skill_HeaderID,
        };
      });
      //   const skillDatafromApi=data.body['final_result']
      console.log(skillDatafromApi);

      //   props.settableData((prevV) => {
      //     const updatedData = prevV.map((existingItem) => {
      //       const matchingItem = skillDatafromApi.find(
      //         (newItem) => newItem.Skill_ID === existingItem.Skill_ID
      //       );
      //       console.log(matchingItem);
      //       return matchingItem ? { existingItem, matchingItem } : existingItem;
      //     });
      //     return updatedData;
      //   });

      props.settableData((prevV) => {
        const areEqual = (obj1, obj2) => obj1.Skill_ID === obj2.Skill_ID; // Example criteria based on Skill_ID

        const objectsToAdd = skillDatafromApi.filter(
          (obj2) => !prevV.some((obj1) => areEqual(obj1, obj2))
        );

        return [...prevV, ...objectsToAdd];
      });

      toast.success(data.body.msg);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setIsPopUpOpen(false);
    }
  };
  console.log("data", data);

  if (loading) {
    return (
      <Box className="loader-wrapper">
        <div className="loader"></div>
      </Box>
    );
  }
  return (
    <div className="tblDiv">
      <input
        type="text"
        value={searchText}
        style={{
          margin: "10px 0",
          width: "150px",
          height: "30px",
          marginLeft: props.isSkillMapping ? "20px" : "0",
        }}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search Skill..."
      />
      <input
        type="text"
        value={props.searchHeader}
        style={{ margin: "10px 20px", width: "150px", height: "30px" }}
        onChange={(e) => props.setSearchHeader(e.target.value)}
        placeholder="Search Header..."
      />
      <table className="tblDisplay skill-management-table" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps({
                    style: {
                      width: column.width,
                      background: "white",
                    },
                  })}
                >
                  {/* {" "} */}
                  {/* {column.render("Header")} */}
                </th>
              ))}
              {/* <th colSpan="2"></th> */}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rowsForTable.map((row) => {
            prepareRow(row);
            console.log(row);
            const isNewHeader = row.original.Header !== lastHeader;
            if (isNewHeader) lastHeader = row.original.Header;
            return (
              <>
                {isNewHeader && (
                  <tr
                    className="header-row"
                    onClick={() => {
                      setSelectedHeader(row.original.Header);
                      setIsCollasped(!isCollasped);
                    }}
                  >
                    {" "}
                    <td
                      colSpan="3"
                      style={{
                        textAlign: "center",
                        border: "1px solid ",
                        background: "white",
                        fontSize: "large",
                      }}
                    >
                      <div
                        style={{ alignItems: "center" }}
                        className="question--container"
                      >
                        {row.original.Header}

                        <div style={{ display: "flex", gap: "10px" }}>
                          {!props.isSkillMapping && (
                            <EditIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setIsPopUpOpen(true);
                                setHeaderInPopup(row.original.Header);
                                setHeaderIDInPopup(row.original.Header_ID);
                              }}
                            ></EditIcon>
                          )}
                          {selectedHeader === row.original.Header &&
                          expanded == row.original.Header ? (
                            <button
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleQuestionClickNegative(row.original.Header)
                              }
                            >
                              -
                            </button>
                          ) : (
                            <button
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleQuestionClick(row.original.Header);
                                console.log(row.original);
                              }}
                            >
                              +
                            </button>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                <tr {...row.getRowProps()}>
                  {/* {row.cells.map((cell) => {
                    return (
                        {selectedHeader === row.original.Header && (
                            <td
                                {...cell.getCellProps()}
                                style={{ textAlign: "center" }}
                            >
                                {cell.render("Cell")}
                            </td>
                        )}
                    );
                  })} */}
                  {row.cells.map(
                    (cell) =>
                      selectedHeader === row.original.Header &&
                      expanded == selectedHeader && (
                        <td
                          {...cell.getCellProps()}
                          style={{ textAlign: "center" }}
                        >
                          {cell.column.Header === "Active" ? (
                            <ToggleHandler
                              skill_id={cell.row.original.Skill_ID}
                              active={cell.row.original.isActive}
                            />
                          ) : cell.column.Header === "Action" ? (
                            <EditIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setIsskillEditButtonclicked(
                                  cell.row.original.Skill_ID
                                );
                                setvalueinInputAfterEdit(
                                  cell.row.original.Title
                                );
                                setISEditSkillClicked(true);
                                console.log("Action clicked", cell);
                                // if (inputRefSkillEditing != null)
                                //   inputRefSkillEditing.current.focus();
                              }}
                            />
                          ) : cell.column.Header === "Skill" &&
                            cell.row.original.Skill_ID ==
                              isSkillEditButtonClicked ? (
                            <>
                              {" "}
                              <div
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "5px",
                                  }}
                                  ref={inputRefSkillEditing}
                                  value={valueinInputAfterEdit}
                                  onChange={(e) =>
                                    setvalueinInputAfterEdit(e.target.value)
                                  }
                                  autoFocus
                                  id={cell.row.original.Skill}
                                  onBlur={() => {
                                    setIsskillEditButtonclicked();
                                    setIsEditingSkillSuccess(false);
                                    setISEditSkillClicked(false);
                                    skillEditHandler(
                                      cell.row.original.Header_ID,
                                      cell.row.original.Skill_ID,
                                      cell.row.original.isActive
                                    );
                                  }}
                                ></input>
                                {/* <button
                                  className="btn btn--primary btn--small"
                                  onClick={() => {
                                    console.log("--------->");
                                    // skillEditHandler(
                                    //   cell.row.original.Header_ID,
                                    //   cell.row.original.Skill_ID,
                                    //   cell.row.original.isActive
                                    // );
                                    setvalueinInputAfterEdit_PrevState(
                                      isSkillEditButtonClicked
                                    );
                                    setIsskillEditButtonclicked();
                                    setIsEditingSkillSuccess(false);
                                    setISEditSkillClicked(false);
                                  }}
                                >
                                  Save
                                </button> */}
                              </div>
                            </>
                          ) : props.isSkillMapping ? (
                            <CheckBoxComponent
                              shouldBeChecked={
                                props.skillsArrayForUser.filter(
                                  (item) =>
                                    item.Skill_ID == row.original.Skill_ID
                                ).length > 0
                                  ? true
                                  : false
                              }
                              isActive={row.original.isActive}
                              skill_id={row.original.Skill_ID}
                              skillValue={row.original.Title}
                              skillsArrayForUser={props.skillsArrayForUser}
                              setSkillsArrayForUser={
                                props.setSkillsArrayForUser
                              }
                            >
                              {cell.render("Cell")}
                            </CheckBoxComponent>
                          ) : (
                            //    : isEditingSkillSuccess &&
                            //     valueinInputAfterEdit_PrevState ==
                            //       cell.row.original.Skill_ID ? (
                            //     valueinInputAfterEdit
                            //   )
                            cell.render("Cell")
                          )}
                        </td>
                      )
                  )}
                </tr>
              </>
            );
          })}
        </tbody>
      </table>

      <PopOutModal
        isOpen={isPopUpOpen}
        heightPopUp="65%"
        bigPopUpHeight=""
        onClose={() => {
          setIsPopUpOpen(false);
          setSkillInInputPopup("");
          setSkillsInPopup([]);
        }}
        content={
          <>
            <div className="rebuttal--body">
              <div className="rebuttal--heading">
                Add Skills
                <button
                  className="rebuttal--main-container__right--buttons-submit"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Submit
                </button>
              </div>

              <div className="skill-inputs">
                <div className="skill-input">
                  <label>Skill</label>
                  <input disabled value={headerInPopup}></input>
                </div>

                <div className="skill-input">
                  <label>Subskill</label>
                  <input
                    value={skillInInputPopup}
                    onChange={(e) => {
                      setSkillInInputPopup(e.target.value);
                    }}
                  ></input>
                  <button
                    onClick={() => {
                      setSkillsInPopup((prevV) => [
                        ...prevV,
                        skillInInputPopup,
                      ]);
                      setSkillInInputPopup("");
                    }}
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="skill-input skill-input-textarea">
                <label>Added Skills</label>
                {/* <textarea
                  rows="20"
                  cols="30"
                  value={skillsInPopup.join("\n")}
                ></textarea> */}
                <ol>
                  {skillsInPopup.map((item) => (
                    <li>{item}</li>
                  ))}
                </ol>
              </div>
            </div>
          </>
        }
      ></PopOutModal>
      <div className="pagination">
        <span>
          Page{" "}
          <strong>
            {/* {rows.length == 0 ? pageIndex : pageIndex + 1} of {pageCount} */}
            {filteredRows.length == 0 ? pageIndex : pageIndex + 1} of{" "}
            {pageCount}
          </strong>{" "}
        </span>
        <button
          className="pagination-button"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          Previous
        </button>
        <button
          className="pagination-button"
          onClick={() => nextPage()}
          // disabled={!canNextPage}
          //   disabled={pageIndex >= Math.ceil(rows.length / currentPageSize) - 1}
          disabled={
            pageIndex >= Math.ceil(filteredRows.length / currentPageSize) - 1
          }
        >
          Next
        </button>
      </div>
      <br></br>
    </div>
  );
};

export default SkillManagementTable;
